import React, { useState } from "react";
import { FaFacebook, FaSquareXTwitter, FaInstagram } from "react-icons/fa6";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const openModal = (modalName: string) => {
    setActiveModal(modalName);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[url('../../public/background-pattern.webp')] bg-repeat">
      <main className="flex-1 w-full mx-auto">
        <div className="max-w-full w-full mx-auto">{children}</div>
      </main>

      <footer className="bg-[#39337d] text-white bg-[url('../../public/footer-pattern.webp')] bg-repeat">
        <div className="w-full md:max-w-[80vw] mx-auto px-6 my-5 flex flex-col md:flex-row justify-between gap-8 md:gap-0">
          <div>
            <img src="/75aniversario.svg" alt="UAT" className="h-24 mb-3" />
            <p className="text-md font-bold opacity-90">
              Unidad Académica Multidisciplinaria de Valle Hermoso
            </p>
            <p className="text-sm opacity-80 mt-3">
              Calle Juárez y 5 de mayo. Zona Centro. C.P. 87500
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between gap-6">
            <div>
              <h4 className="font-semibold text-lg">Contacto</h4>
              <p className="text-sm mt-2">
                Email:{" "}
                <a
                  href="mailto:halcones@uat.edu.mx "
                  className="text-[var(--uat-gold)]"
                >
                  halcones@uat.edu.mx
                </a>
              </p>
              <p className="text-sm mt-1">
                Soporte:{" "}
                <a
                  href="mailto:support@feriadeemprendedoresuat.site"
                  className="text-[var(--uat-gold)]"
                >
                  support@feriadeemprendedoresuat.site
                </a>
              </p>
              <p className="text-sm mt-1">Tel: (868) 204 4080</p>
              <p className="text-sm mt-1">
                Conmutador: 834 318 18 00 Ext: 6800
              </p>
            </div>
            <div>
              <h5 className="text-lg font-semibold">Enlaces útiles</h5>
              <ul className="mt-2 space-y-2 text-sm">
                <li>
                  <button
                    onClick={() => openModal("privacy")}
                    className="text-[var(--uat-gold)]"
                  >
                    Política de privacidad
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => openModal("terms")}
                    className="text-[var(--uat-gold)]"
                  >
                    Términos y condiciones
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => openModal("faq")}
                    className="text-[var(--uat-gold)]"
                  >
                    Ayuda / FAQ
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-lg">Síguenos</h4>
            <div className="flex items-center gap-3 mt-3">
              <a
                href="https://www.facebook.com/UATmx/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--uat-gold)] hover:text-[var(--uat-blue)] transition-colors duration-200"
              >
                <FaFacebook size={16} />
              </a>
              <a
                href="https://x.com/uat_mx"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--uat-gold)] hover:text-[var(--uat-blue)] transition-colors duration-200"
              >
                <FaSquareXTwitter size={16} />
              </a>
              <a
                href="https://www.instagram.com/uatmx"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--uat-gold)] hover:text-[var(--uat-blue)] transition-colors duration-200"
              >
                <FaInstagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-4 py-4">
          <div className="w-full md:max-w-[80vw] mx-auto px-6 text-xs text-white/80 flex flex-col md:flex-row justify-between gap-3">
            <span>
              © {new Date().getFullYear()} Universidad Autónoma de Tamaulipas
            </span>
            <span>Desarrollado por Coordinación de Vinculación</span>
          </div>
        </div>

        {activeModal && (
          <div
            className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
            onClick={handleBackdropClick}
          >
            <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden">
              {/* Header del Modal */}
              <div className="bg-gradient-to-r from-[#39337d] to-[#4a4494] text-white px-6 py-4 flex items-center justify-between">
                <h3 className="text-2xl font-bold">
                  {activeModal === "privacy" && "Política de Privacidad"}
                  {activeModal === "terms" && "Términos y Condiciones"}
                  {activeModal === "faq" && "Preguntas Frecuentes"}
                </h3>
                <button
                  onClick={closeModal}
                  className="text-white hover:bg-white/20 rounded-full w-8 h-8 flex items-center justify-center transition"
                >
                  ✕
                </button>
              </div>

              {/* Contenido del Modal */}
              <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)]">
                {activeModal === "privacy" && (
                  <div className="space-y-4 text-gray-700">
                    <p className="text-sm text-gray-600">
                      Última actualización:{" "}
                      {new Date().toLocaleDateString("es-MX")}
                    </p>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        1. Información que Recopilamos
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La Universidad Autónoma de Tamaulipas (UAT) recopila
                        información personal de los estudiantes participantes en
                        la Feria de Emprendedores, incluyendo nombre completo,
                        matrícula, correo electrónico institucional, información
                        del emprendimiento y documentación relacionada.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        2. Uso de la Información
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La información recopilada se utiliza exclusivamente
                        para:
                      </p>
                      <ul className="list-disc list-inside text-sm space-y-1 ml-4 mt-2">
                        <li>
                          Gestionar inscripciones a la Feria de Emprendedores
                        </li>
                        <li>Contactar a los participantes sobre el evento</li>
                        <li>Evaluar y aprobar solicitudes de participación</li>
                        <li>Generar reportes estadísticos internos</li>
                        <li>Mejorar la experiencia del evento</li>
                      </ul>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        3. Protección de Datos
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT implementa medidas de seguridad técnicas y
                        administrativas para proteger la información personal
                        contra acceso no autorizado, alteración, divulgación o
                        destrucción. Los datos son almacenados en sistemas
                        seguros y el acceso está limitado únicamente al personal
                        autorizado.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        4. Compartir Información
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT no comparte, vende ni alquila información
                        personal a terceros. La información solo se compartirá
                        con autoridades competentes cuando sea requerido por
                        ley.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        5. Derechos del Usuario
                      </h4>
                      <p className="text-sm leading-relaxed">
                        Los usuarios tienen derecho a:
                      </p>
                      <ul className="list-disc list-inside text-sm space-y-1 ml-4 mt-2">
                        <li>Acceder a su información personal</li>
                        <li>Solicitar corrección de datos inexactos</li>
                        <li>Solicitar la eliminación de sus datos</li>
                        <li>Oponerse al procesamiento de su información</li>
                      </ul>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        6. Contacto
                      </h4>
                      <p className="text-sm leading-relaxed">
                        Para ejercer sus derechos o cualquier pregunta sobre
                        privacidad, contacte a:{" "}
                        <a
                          href="mailto:support@feriadeemprendedoresuat.site"
                          className="text-blue-600 hover:underline"
                        >
                          support@feriadeemprendedoresuat.site
                        </a>
                      </p>
                    </section>
                  </div>
                )}

                {activeModal === "terms" && (
                  <div className="space-y-4 text-gray-700">
                    <p className="text-sm text-gray-600">
                      Última actualización:{" "}
                      {new Date().toLocaleDateString("es-MX")}
                    </p>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        1. Aceptación de Términos
                      </h4>
                      <p className="text-sm leading-relaxed">
                        Al registrarse en la Feria de Emprendedores de la UAT,
                        usted acepta estos términos y condiciones en su
                        totalidad. Si no está de acuerdo con estos términos, no
                        debe utilizar esta plataforma.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        2. Elegibilidad
                      </h4>
                      <p className="text-sm leading-relaxed">
                        Solo estudiantes activos de la Universidad Autónoma de
                        Tamaulipas con matrícula vigente pueden participar en la
                        Feria de Emprendedores. Los participantes deben
                        proporcionar información veraz y actualizada.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        3. Responsabilidades del Participante
                      </h4>
                      <ul className="list-disc list-inside text-sm space-y-1 ml-4">
                        <li>
                          Proporcionar información precisa y completa en el
                          registro
                        </li>
                        <li>
                          Mantener la confidencialidad de sus credenciales de
                          acceso
                        </li>
                        <li>
                          Presentar un emprendimiento original y de su autoría
                        </li>
                        <li>
                          Cumplir con las fechas y requisitos establecidos
                        </li>
                        <li>
                          Respetar los derechos de propiedad intelectual de
                          terceros
                        </li>
                        <li>Mantener conducta profesional durante el evento</li>
                      </ul>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        4. Proceso de Selección
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT se reserva el derecho de aprobar o rechazar
                        cualquier solicitud de participación basándose en
                        criterios de evaluación establecidos. Las decisiones del
                        comité evaluador son finales e inapelables.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        5. Propiedad Intelectual
                      </h4>
                      <p className="text-sm leading-relaxed">
                        Los participantes conservan todos los derechos sobre sus
                        emprendimientos. Sin embargo, otorgan a la UAT permiso
                        para fotografiar, grabar y publicar contenido
                        relacionado con el evento para fines promocionales y
                        educativos.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        6. Cancelación y Modificaciones
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT se reserva el derecho de modificar fechas,
                        requisitos o cancelar el evento por causas de fuerza
                        mayor. Los participantes serán notificados con
                        antelación sobre cualquier cambio significativo.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        7. Limitación de Responsabilidad
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT no se hace responsable por pérdidas, daños o
                        lesiones que puedan ocurrir durante el evento. Los
                        participantes asisten bajo su propio riesgo.
                      </p>
                    </section>

                    <section>
                      <h4 className="text-lg font-semibold text-[#39337d] mb-2">
                        8. Modificaciones a los Términos
                      </h4>
                      <p className="text-sm leading-relaxed">
                        La UAT puede actualizar estos términos en cualquier
                        momento. El uso continuado de la plataforma después de
                        los cambios constituye la aceptación de los nuevos
                        términos.
                      </p>
                    </section>
                  </div>
                )}

                {activeModal === "faq" && (
                  <div className="space-y-6">
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                      <h4 className="font-semibold text-blue-900 mb-1">
                        ¿Quiénes pueden participar en la Feria de Emprendedores?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Todos los estudiantes activos de la Universidad Autónoma
                        de Tamaulipas con matrícula vigente pueden participar
                        presentando sus proyectos de emprendimiento.
                      </p>
                    </div>

                    <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <h4 className="font-semibold text-green-900 mb-1">
                        ¿Cuáles son los requisitos para registrarme?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Necesitas tu nombre completo, matrícula estudiantil,
                        correo electrónico institucional, información de tu
                        emprendimiento (nombre, descripción, categoría) y
                        opcionalmente el logo de tu negocio.
                      </p>
                    </div>

                    <div className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded">
                      <h4 className="font-semibold text-purple-900 mb-1">
                        ¿Cuánto tiempo tarda la aprobación de mi solicitud?
                      </h4>
                      <p className="text-sm text-gray-700">
                        El proceso de revisión generalmente toma entre 3 a 5
                        días hábiles. Recibirás un correo electrónico con el
                        resultado de tu solicitud.
                      </p>
                    </div>

                    <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded">
                      <h4 className="font-semibold text-yellow-900 mb-1">
                        ¿Puedo modificar mi información después de registrarme?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Sí, puedes contactar a la Coordinación de Vinculación en
                        support@feriadeemprendedoresuat.site para solicitar
                        cambios en tu registro antes de la fecha límite
                        establecida.
                      </p>
                    </div>

                    <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                      <h4 className="font-semibold text-red-900 mb-1">
                        ¿Qué pasa si mi solicitud es rechazada?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Si tu solicitud es rechazada, recibirás un correo con
                        las razones específicas. Podrás realizar ajustes a tu
                        propuesta y volver a aplicar si el periodo de registro
                        sigue abierto.
                      </p>
                    </div>

                    <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 rounded">
                      <h4 className="font-semibold text-indigo-900 mb-1">
                        ¿Hay algún costo por participar?
                      </h4>
                      <p className="text-sm text-gray-700">
                        No, la participación en la Feria de Emprendedores es
                        completamente gratuita para todos los estudiantes de la
                        UAT.
                      </p>
                    </div>

                    <div className="bg-pink-50 border-l-4 border-pink-500 p-4 rounded">
                      <h4 className="font-semibold text-pink-900 mb-1">
                        ¿Recibiré algún tipo de certificado o reconocimiento?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Sí, todos los participantes recibirán un certificado de
                        participación. Además, habrá premios especiales para los
                        proyectos más destacados según diferentes categorías.
                      </p>
                    </div>

                    <div className="bg-teal-50 border-l-4 border-teal-500 p-4 rounded">
                      <h4 className="font-semibold text-teal-900 mb-1">
                        ¿A quién contacto si tengo más preguntas?
                      </h4>
                      <p className="text-sm text-gray-700">
                        Puedes contactar a la Coordinación de Vinculación:
                        <br />
                        📧 Email:{" "}
                        <a
                          href="mailto:support@feriadeemprendedoresuat.site"
                          className="text-blue-600 hover:underline"
                        >
                          support@feriadeemprendedoresuat.site
                        </a>
                        <br />
                        📧 Soporte:{" "}
                        <a
                          href="mailto:support@feriadeemprendedoresuat.site"
                          className="text-blue-600 hover:underline"
                        >
                          support@feriadeemprendedoresuat.site
                        </a>
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Footer del Modal */}
              <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end">
                <button
                  onClick={closeModal}
                  className="px-6 py-2 bg-[#39337d] text-white rounded-lg hover:bg-[#4a4494] transition font-medium"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </footer>
    </div>
  );
};

export default Layout;
